import { Injectable } from '@angular/core';
import { TableDatasource } from '@core/api/table.datasource';
import { LogSearchParams } from '@features/log/log-search/log-search-params.model';
import { LogEntry } from '@features/log/log.model';

@Injectable({
  providedIn: 'root',
})
export class LogDatasource extends TableDatasource<LogEntry, LogSearchParams> {
  endpoint = '/api/logsearch';
  defaultSortField = 'id';
}
